import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { updatePoints, markNotificationAsRead } from '../../slices/authSlice';
import PostModal from '../Topics/PostModal'; // 공용 모달 임포트
import { useNavigate } from 'react-router-dom';

const MyPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const [activities, setActivities] = useState({ myPosts: [], myComments: [] });
  const [selectedPost, setSelectedPost] = useState(null); // 선택된 게시글 데이터 저장
  

  useEffect(() => {
    const fetchMyActivities = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/api/users/activities', {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("내 활동 내역:", res.data);

        setActivities(res.data);

        // 🚩 [추가] 알림 확인 처리 (서버에 확인했다고 알림)
        if (user?.hasNewNotification) {
          await axios.put('https://the-pivot-logical-battleground.onrender.com/api/auth/clear-notification', {}, {
             headers: { Authorization: `Bearer ${token}` }
          });
          // 참고: 리덕스 상태 업데이트는 새로고침 후에 반영됩니다. 
          // (즉각 반영하려면 authSlice에 액션을 추가해야 하지만, MVP에서는 이 정도면 충분합니다.)
        }

      } catch (err) {
        console.error("활동 내역 로드 실패", err);
      }
    };

    // 🚩 [추가] 포인트 로그 가져오기 함수
    {/*}
    const fetchPointLogs = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://the-pivot-logical-battleground.onrender.com/api/payments/logs', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPointLogs(res.data);
      } catch (err) {
        console.error("포인트 로그 로드 실패", err);
      }
    };
    */}

    fetchMyActivities();
  }, []);

  const handleopenmodal = (post, type) => {
    console.log(`2. [${type}] 클릭됨. 선택된 데이터:`, post);
    setSelectedPost(post);

    // 🚩 [핵심] 클릭 시, 만약 안 읽은 글이라면 읽음 처리(Red Dot 삭제) 요청!
    if (user?.unreadPostIds?.includes(post._id)) {
        dispatch(markNotificationAsRead(post._id));
    }
  }

  

  {/*
  const fetchPayments = async () => {
    try {
      const token = localStorage.getItem('token');
      // 🚩 서버 주소를 명확히 적어주거나, /api/payments/my가 맞는지 확인
      const res = await axios.get('https://the-pivot-logical-battleground.onrender.com/api/payments/my', {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("결제 내역 데이터 수신:", res.data); // 데이터가 오는지 콘솔로 확인
      setPayments(res.data);
    } catch (err) {
      console.error("결제 내역 로드 실패", err);
    }
  };
  */}

  

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>내 전적 기록</h1>
      <div style={styles.userSummary}>
        <span style={user?.currentFaction === 'BLUE' ? styles.blueText : styles.redText}>
          [{user?.currentFaction || '무소속'}]
        </span> {user?.nickname} 논객님 |
        <span style={{color: '#ffd700', marginLeft: '10px'}}> {user?.points?.toLocaleString()} P</span>
      </div>

      {/* 🚩 [추가] 포인트 충전 섹션 */}
      {/*
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>전투 자금 보급 (충전)</h2>
        <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
          {[100, 1000, 3000, 5000, 10000, 30000].map(amt => (
            <button 
              key={amt} 
              onClick={() => handleCharge(amt)}
              style={styles.chargeBtn}
            >
              {amt.toLocaleString()}P
            </button>
          ))}
        </div>
      </div>
      */}

      {/* 🚩 [NEW] 포인트 관리 이동 버튼 */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <button 
          onClick={() => navigate('/mypage/history')}
          style={{
            background: '#222',
            border: '1px solid #00d4ff',
            color: '#00d4ff',
            padding: '12px 25px',
            borderRadius: '4px',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: '100%',
            maxWidth: '400px'
          }}
        >
          💳 포인트 충전 및 사용 내역 관리 &gt;
        </button>
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>내가 작성한 논리 (게시글)</h2>
        {activities.myPosts.length === 0 && <p style={{color:'#666'}}>작성한 게시글이 없습니다.</p>}
        {activities.myPosts.map(post => (
          <div key={post._id} style={styles.activityCard} onClick={() => handleopenmodal(post, '게시글')}>
            <small style={{...styles.topicTag, color: post.faction === 'BLUE' ? '#00d4ff' : '#ff4e50'}}>topic: {post.topicId?.title?.split('\n')[0]}</small>
            
            {/* 🚩 [핵심] 안 읽은 글(unreadPostIds에 포함됨)이면 빨간 점 표시 */}
            {user?.unreadPostIds?.includes(post._id) && (
                <span style={styles.redDot}>🔴 New Feedback</span>
            )}

            <p style={styles.cardContent}>{post.content}</p>
          </div>
        ))}
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>내가 남긴 분석 (댓글)</h2>
        {activities.myComments.length === 0 && <p style={{color:'#666'}}>작성한 댓글이 없습니다.</p>}
        {activities.myComments.map(comment => (
          <div key={comment._id} style={styles.activityCard} onClick={() => {
             if (comment.postId) {
               handleopenmodal(comment.postId, '댓글');
             } else {
               alert("원문 게시글이 삭제되어 모달을 열 수 없습니다.");
             }
          }}>
            <small style={{...styles.topicTag, color: comment.faction === 'BLUE' ? '#00d4ff' : '#ff4e50'}}>topic: {comment.postId?.topicId?.title?.split('\n')[0]}</small>
            <p style={styles.myCommentText}>💬 {comment.content}</p>
            <p style={styles.originPostPreview}>원문 요약: {comment.postId?.content?.substring(0, 30)}...</p>
          </div>
        ))}
      </div>

      {/* 🛡️ 공용 PostModal 적용: 이제 상세페이지와 동일한 기능(댓글/좋아요)이 작동합니다 */}
      {selectedPost && (
        <PostModal 
          post={selectedPost} 
          user={user} 
          onClose={() => {
            console.log("3. 모달 닫힘.");
            setSelectedPost(null);
          }}
        />
      )}
      
      {/* 🚩 [추가] 결제 내역 섹션 */}
      {/*
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>보급 기록 (결제/환불 내역)</h2>
        {payments.length === 0 && <p style={{color:'#666'}}>결제 내역이 없습니다.</p>}
        {payments.map(pay => (
          <div key={pay._id} style={styles.paymentCard}>
            <div>
              <span style={{fontWeight: 'bold'}}>{pay.amount.toLocaleString()} P</span>
              <small style={{marginLeft: '10px', color: '#666'}}>{new Date(pay.createdAt).toLocaleDateString()}</small>
            </div>
            {pay.status === 'paid' ? (
              <button 
                onClick={() => handleCancel(pay.imp_uid, pay.amount)}
                style={styles.cancelBtn}
              >
                환불하기
              </button>
            ) : (
              <span style={{color: '#ff4e50', fontSize: '0.8rem'}}>환불완료</span>
            )}
          </div>
        ))}
      </div>
      */}

      {/* 🚩 [추가] 포인트 입출금 내역 섹션 (결제 내역 위에 배치 추천) */}
      {/*
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>포인트 사용내역</h2>
        {pointLogs.length === 0 && <p style={{color:'#666'}}>내역이 없습니다.</p>}
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {pointLogs.map(log => (
            <div key={log._id} style={{
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '12px', 
              background: '#161616', 
              borderRadius: '6px',
              borderLeft: log.amount > 0 ? '4px solid #00d4ff' : '4px solid #ff4e50' // 수입은 파랑, 지출은 빨강
            }}>
              <div>
                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>{log.description}</span>
                <span style={{ fontSize: '0.8rem', color: '#666' }}>
                  {new Date(log.createdAt).toLocaleDateString()}
                </span>
              </div>
              <span style={{ 
                color: log.amount > 0 ? '#00d4ff' : '#ff4e50', 
                fontWeight: 'bold' 
              }}>
                {log.amount > 0 ? '+' : ''}{log.amount.toLocaleString()} P
              </span>
            </div>
          ))}
        </div>
      </div>
      */}

    </div>
  );
};

const styles = {
  container: { padding: '40px 20px', backgroundColor: '#0a0a0a', minHeight: '100vh', color: '#fff' },
  title: { textAlign: 'center', marginBottom: '10px' },
  userSummary: { textAlign: 'center', marginBottom: '40px', color: '#888' },
  section: { maxWidth: '800px', margin: '0 auto 40px auto' },
  sectionTitle: { borderBottom: '1px solid #333', paddingBottom: '10px', fontSize: '1.2rem' },
  activityCard: { background: '#161616', padding: '15px', borderRadius: '8px', marginTop: '10px', cursor: 'pointer', border: '1px solid #222' },
  topicTag: { color: '#00d4ff', fontSize: '0.75rem' },
  cardContent: { margin: '5px 0', color: '#ccc' },
  myCommentText: { margin: '5px 0', color: '#fff', fontWeight: 'bold' },
  originPostPreview: { fontSize: '0.8rem', color: '#666' },
  blueText: { color: '#00d4ff', fontWeight: 'bold' },
  redText: { color: '#ff4e50', fontWeight: 'bold' },

  chargeBtn: {
    backgroundColor: '#333',
    color: '#fff',
    border: '1px solid #00d4ff',
    padding: '8px 15px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: '0.3s',
  },
  paymentCard: { 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    background: '#161616', 
    padding: '15px', 
    borderRadius: '8px', 
    marginTop: '10px', 
    border: '1px solid #222' 
  },
  cancelBtn: {
    backgroundColor: 'transparent',
    color: '#ff4e50',
    border: '1px solid #ff4e50',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    cursor: 'pointer'
  },

  // 🚩 [추가] 빨간 점 스타일
  redDot: {
      color: '#ff4e50',
      fontWeight: 'bold',
      fontSize: '0.8rem',
      marginLeft: '10px',
      animation: 'pulse 1s infinite'
  }

};

export default MyPage;